import React from "react";
import about_img from "../assets/about_img.jpg";
import { Link } from "react-router-dom";

const AboutUs = () => {
  return (
    <div className="flex flex-col md:flex-row gap-2 md:h-[80vh] bg-pimary items-center justify-center p-4 md:px-12 md:py-4">
      {/* Image Section */}
      <div className="flex justify-center">
        <img
          src={about_img}
          alt="GENT 2025 – Graphene Conference"
          loading="lazy"
          className="h-[80%] md:max-h-[100%] w-auto md:w-[80vh] md:mx-16 rounded-2xl object-cover"
        />
      </div>

      {/* Text Content */}
      <div className="flex flex-col w-full md:w-2/3">
        <h1 className="text-xl md:text-3xl font-bold my-2">
          <span className="text-one">Welcome to</span>{" "}
          GENT 2025 – Graphene & Nanotech Summit
        </h1>
        <p className="text-base my-2">
          The Global Summit on Graphene & Nanotechnology <strong> (GENT 2025) </strong> is the ultimate convergence of innovation, discovery, and collaboration in the fields of graphene research and nanotechnology advancements. As part of the <Link to="https://graphene.helixconferences.com/" className="text-one font-bold" target="_blank"> International Graphene Conclave,</Link> it highlights breakthrough technologies and real-world applications shaping the future of science and engineering.
        </p>
        <blockquote className="italic text-one my-2 border-l-4 border-one pl-4">
          “Bridging Science & Industry through Nano-Innovation.”
        </blockquote>

        <Link to="/about-GENT">
          <button className="flex bg-coal text-primary px-6 md:px-8 py-2 my-4 rounded-full text-sm md:text-base">
            Know More
          </button>
        </Link>
      </div>
    </div>
  );
};

export default AboutUs;
